export const WHATSAPP_NUMBER = "34653747630";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hola Socify, quiero impulsar mi negocio. ¿Hablamos?"
)}`;
export const EMAIL = "socifymkt@gmail.com";
export const INSTAGRAM_URL = "https://instagram.com/socify_marketing";

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -90 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const SERVICES = [
  {
    id: "tiendas-online",
    num: "01",
    name: "Tiendas Online",
    tagline: "Shopify & WooCommerce de alta conversión",
    price: 890,
    priceLabel: "Desde 890 €",
    priceNote: "pago único / proyecto",
    popular: false,
    features: [
      "Diseño y configuración completa",
      "Catálogo de productos estructurado",
      "Pagos y gestión de pedidos",
      "Optimización total para móvil",
    ],
  },
  {
    id: "diseno-grafico",
    num: "02",
    name: "Diseño Gráfico",
    tagline: "Identidad visual que vende y destaca",
    price: 250,
    priceLabel: "Desde 250 €",
    priceNote: "por pack de piezas",
    popular: false,
    features: [
      "Logos e identidad de marca",
      "Flyers, carteles y menús",
      "Banners para redes y web",
      "Material publicitario completo",
    ],
  },
  {
    id: "community-manager",
    num: "03",
    name: "Community Manager",
    tagline: "Tu Instagram y Facebook, siempre activos",
    price: 390,
    priceLabel: "390 €",
    priceNote: "/ mes · sin permanencia",
    popular: true,
    features: [
      "3 publicaciones semanales",
      "1–2 Reels estratégicos",
      "Stories + respuesta a mensajes y comentarios",
      "Calendario de contenido mensual",
    ],
  },
  {
    id: "google-business",
    num: "04",
    name: "Google Business",
    tagline: "Domina las búsquedas de tu ciudad",
    price: 190,
    priceLabel: "190 €",
    priceNote: "/ mes",
    popular: false,
    features: [
      "Optimización completa de tu ficha",
      "Publicaciones y fotos periódicas",
      "Respuesta profesional a reseñas",
      "Mejora de presencia local en Maps",
    ],
  },
  {
    id: "paginas-web",
    num: "05",
    name: "Páginas Web",
    tagline: "Tu mejor escaparate digital, abierto 24/7",
    price: 490,
    priceLabel: "Desde 490 €",
    priceNote: "pago único",
    popular: false,
    features: [
      "Web sencilla y moderna para empresas",
      "Botón de WhatsApp integrado",
      "Formularios de contacto",
      "Diseño móvil + SEO básico",
    ],
  },
];
